import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { EnoteModule } from '../../../../../enote/enote.module';
import { MedicationSummaryComponent } from './medication-summary.component';

// MedicationSummaryComponent lives in its own module so both HealthModule and
// UpdoxMessagingModule can use it without creating a circular module dependency.
@NgModule({
  declarations: [MedicationSummaryComponent],
  exports: [MedicationSummaryComponent],
  imports: [CommonModule, FormsModule, ModalModule, TypeaheadModule, EnoteModule],
})
export class MedicationSummaryModule {}
